import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
import { Message, Text } from "@grandvisionhq/iris-ui";
import { DeliveryIndicatorLoader } from "./DeliveryIndicatorLoader.js";
/* empty css                                                                         */
const DeliveryIndicator = ({
  labels,
  isLoading = false,
  hasError = false,
  view = "full",
  deliveryMessage,
  fallbackLabel,
  tooltipSlot,
  className,
  ...rest
}) => {
  if (isLoading && !hasError) {
    return /* @__PURE__ */ React.createElement(DeliveryIndicatorLoader, null);
  }
  if (hasError || view !== "short" && !deliveryMessage) {
    return fallbackLabel ? /* @__PURE__ */ React.createElement("div", { className: "delivery-indicator delivery-indicator--text" }, fallbackLabel) : null;
  }
  const messageElement = /* @__PURE__ */ React.createElement("p", { className: "delivery-indicator__message", "data-t": "delivery-indicator-message" }, deliveryMessage);
  const tooltipElement = tooltipSlot ? /* @__PURE__ */ React.createElement("div", { className: "delivery-indicator__tooltip-slot" }, tooltipSlot) : null;
  let content = null;
  switch (view) {
    case "short":
      content = labels?.deliveryIndication ? /* @__PURE__ */ React.createElement("span", { className: "delivery-indicator__message", "data-t": "delivery-short" }, labels.deliveryIndication) : null;
      break;
    case "text":
      content = /* @__PURE__ */ React.createElement(React.Fragment, null, messageElement, tooltipElement);
      break;
    case "icon":
    case "usp":
      content = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "delivery-indicator__icon" }, /* @__PURE__ */ React.createElement(Icon, { name: "delivery" })), /* @__PURE__ */ React.createElement("div", { className: "delivery-indicator__icon-content" }, /* @__PURE__ */ React.createElement(
        Text,
        {
          variant: "caption",
          component: "span",
          className: "delivery-indicator__message",
          "data-t": "delivery-indicator-message"
        },
        deliveryMessage
      ), tooltipElement));
      break;
    case "full":
      content = /* @__PURE__ */ React.createElement(
        Message,
        {
          variant: "info",
          icon: "PackageMoving",
          className: "alert-m-default",
          "data-t": "delivery-alert"
        },
        /* @__PURE__ */ React.createElement("div", null, messageElement, tooltipElement)
      );
      break;
    default:
      throw new Error(`Undefined view: ${view}`);
  }
  const ContainerComponent = view === "usp" ? "li" : "div";
  return /* @__PURE__ */ React.createElement(
    ContainerComponent,
    {
      "data-t": rest["data-t"],
      className: classnames("delivery-indicator", `delivery-indicator--${view}`, className)
    },
    content
  );
};
export {
  DeliveryIndicator
};
//# sourceMappingURL=DeliveryIndicator.js.map
